<template>
  <div id="available-invoice">
    <h2 class="title">FACTURAS DISPONIBLES</h2>
    <p>
      Revisa y descarga tus facturas disponibles hasta el día de hoy
    </p>
    <div class="table-header flex">
      <h4 class="table-title">Folio</h4>
      <h4 class="table-title">Fecha</h4>
      <h4 class="table-title">RFC</h4>
      <h4 class="table-title">Razón Social</h4>
      <h4 class="table-title">Total</h4>
      <h4 class="table-title dspl-none-m dspl-none-sm">PDF</h4>
      <h4 class="table-title dspl-none-m dspl-none-sm">XML</h4>
    </div>
    <div class="data-table">
      <TableRow
        v-for="invoice in invoices"
        :key="invoice.id"
        :invoice="invoice"
        />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TableRow from '@/components/Invoices/TableRow'

export default {
  name: 'Invoices',
  components: {
    TableRow
  },
  computed: {
    ...mapGetters('invoices', [
      'invoices'
    ])
  },
  methods: {
    ...mapActions('invoices', [
      'getInvoices'
    ])
  },
  beforeMount: function () {
    this.getInvoices()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#available-invoice {
  margin: 1rem 2rem;
  text-align: start;
}

.title {
  color: $grey;
}

.table-header {
  background-color: $white;
  border-radius: 20px;
  margin: 2rem 0;
}

.table-title {
  text-align: center;
  margin: .75rem 0;
  width: calc(100% / 7);
}

.data-table {
  background-color: $white;
  border-radius: 20px;
  width: 100%;
  max-height: 50vh;
  overflow-y: scroll;
}

@media screen and (max-width: 60rem) {
  .table-title {
    width: calc(100% / 4)
  }

  h2 {
    font-size: 1.25rem;
  }

  h4 {
    font-size: .75rem;
  }
}
</style>
